import React, { useEffect, useMemo } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { fetchFeaturedMarketplaceComponents } from 'ducks/marketplace'

import SectionsTab from './ResponsiveAddMenu/SectionsTab'
import FeaturesTab from './ResponsiveAddMenu/FeaturesTab'
import GlobalSearch from './ResponsiveAddMenu/GlobalSearch'

import TabBar from './TabBar'
import ComponentsTab from './ComponentsTab'
import ScreensTab from './ScreensTab'
import ShortcutsMenu from './ShortcutsMenu'

import './AddObject.scss'

const componentTab = {
  id: 'component',
  title: 'Components',
  component: ComponentsTab,
}

const sectionTab = {
  id: 'section',
  title: 'Sections',
  component: SectionsTab,
}

const featureTab = {
  id: 'feature',
  title: 'Features',
  component: FeaturesTab,
}

const AddPanel = props => {
  const {
    match: {
      params: { appId },
    },
    magicLayout,
    location,
    app,
    isXanoApp,
  } = props
  const dispatch = useDispatch()

  useEffect(() => {
    if (magicLayout) {
      dispatch(fetchFeaturedMarketplaceComponents())
    }
  }, [magicLayout])

  const mobileOnly = app?.webSettings?.layoutMode === 'mobile'

  const tabs = useMemo(() => {
    const defaultTabs = mobileOnly ? [componentTab] : [componentTab, sectionTab]

    if (isXanoApp) {
      return defaultTabs
    }

    return [...defaultTabs, featureTab]
  }, [isXanoApp, mobileOnly])

  if (!app?.primaryPlatform) {
    return null
  }

  if (magicLayout) {
    const searchActive = location?.pathname.includes('search')

    return (
      <div className="responsive-add-menu">
        <ShortcutsMenu />
        <GlobalSearch appId={appId} />
        {!searchActive && (
          <TabBar
            initialActiveTab="component"
            tabs={tabs}
            extraProps={{ appId }}
          />
        )}
      </div>
    )
  }

  return (
    <>
      <ShortcutsMenu />
      <TabBar
        initialActiveTab="component"
        tabs={[
          { id: 'component', title: 'ADD COMPONENT', component: ComponentsTab },
          { id: 'screen', title: 'ADD SCREEN', component: ScreensTab },
        ]}
        extraProps={{ appId }}
      />
    </>
  )
}

export default withRouter(AddPanel)
